// extracted by css-extract-rspack-plugin
export default {"closeIcon":"l3RPF"};